import { useEffect, useState } from "react";

import { getSupabaseClient } from "../providers/supabase/supabase";

export type Prices = { email: number; mobile: number; team: number };

/** Barème des crédits (e-mail, mobile, équipe), lu une fois ; le débit lui-même est fait par le worker. */
export const useCreditPrices = (): Prices | null => {
  const [prices, setPrices] = useState<Prices | null>(null);
  useEffect(() => {
    // Sans client Supabase (tests sur données fictives), pas de barème : le compteur des en-têtes reste affiché.
    let client;
    try {
      client = getSupabaseClient();
    } catch {
      return;
    }
    client
      .from("credit_prices")
      .select("action, credits")
      .in("action", ["email", "mobile", "team"])
      .then(({ data }) => {
        if (!data) return;
        const price = (action: string) =>
          data.find((row) => row.action === action)?.credits ?? 0;
        setPrices({
          email: price("email"),
          mobile: price("mobile"),
          team: price("team"),
        });
      });
  }, []);
  return prices;
};
